export class State {
	loading: boolean;
	ancillaryToPay: { name: string, count: number, total: number, active: boolean, discount: number, id?: string };
	ancillariesAdded: Array<{ name: string, count: number, total: number, active: boolean, discount: number, id?: string }>;
	milesInFlightDiscount: { cash: number, miles: number };
	processAncillary: number;
	ancillaryTotalToPay: { cash: number, miles: number };
	originalBookingCost: number; // temporary until refactor
	discountedBookingCost: number; // temporary until refactor
}

export const initialState: State = {
	loading: false,
	ancillaryToPay: null,
	ancillariesAdded: [],
	milesInFlightDiscount: null,
	processAncillary: 0,
	ancillaryTotalToPay: null,
	originalBookingCost: 0,
	discountedBookingCost: 0
};

